import {
    GET_MERCHANT_INFO_REQUEST,
    GET_MERCHANT_INFO_SUCCESS,
    GET_MERCHANT_INFO_ERROR,
    FETCH_PG_CONFIG_EDIT_REQUEST,
    FETCH_PG_CONFIG_EDIT_SUCCESS,
    FETCH_PG_CONFIG_EDIT_ERROR,
    FETCH_ROUTER_DETAILS_REQUEST,
    FETCH_ROUTER_DETAILS_SUCCESS,
    FETCH_ROUTER_DETAILS_ERROR,
    FETCH_SURCHARGE_DETAILS_REQUEST,
    FETCH_SURCHARGE_DETAILS_SUCCESS,
    FETCH_SURCHARGE_DETAILS_ERROR,
    UPDATE_MERCHANT_DATA_REQUEST,
    UPDATE_MERCHANT_DATA_SUCCESS,
    UPDATE_MERCHANT_DATA_ERROR,
    UPDATE_PG_CONFIG_DATA_REQUEST,
    UPDATE_PG_CONFIG_DATA_SUCCESS,
    UPDATE_PG_CONFIG_DATA_ERROR,
    UPDATE_ROUTING_DATA_REQUEST,
    UPDATE_ROUTING_DATA_SUCCESS,
    UPDATE_ROUTING_DATA_ERROR,
    UPDATE_SURCHARGE_DATA_REQUEST,
    UPDATE_SURCHARGE_DATA_SUCCESS,
    UPDATE_SURCHARGE_DATA_ERROR,
    UPDATE_SECTION_DETAILS_REQUEST,
    UPDATE_SECTION_DETAILS_SUCCESS,
    UPDATE_SECTION_DETAILS_ERROR,
    RESET_UPDATE_DATA_SUCCESS_KEY,
    GET_MERCHANT_SECTION_INFO_REQUEST,
    GET_MERCHANT_SECTION_INFO_SUCCESS,
    GET_MERCHANT_SECTION_INFO_ERROR,
    SET_SELECTED_ENTITY_REQUEST,
    SET_SELECTED_ENTITY_SUCCESS,
    SET_SELECTED_ENTITY_ERROR,
    FETCH_BASIC_FORM_DATA,
    FETCH_BASIC_FORM_DATA_SUCCESS,
    FETCH_BASIC_FORM_DATA_ERROR,
    UPDATE_SETTLEMENT_DATA_REQUEST,
    UPDATE_SETTLEMENT_DATA_SUCCESS,
    UPDATE_SETTLEMENT_DATA_ERROR,
    ADD_MERCHANT_STEP_UPDATE_MAKER_ERROR,
    ADD_MERCHANT_STEP_UPDATE_MAKER_REQUEST,
    ADD_MERCHANT_STEP_UPDATE_MAKER_SUCCESS,
} from './editMerchant.constants';

export const getMerchantInfoRequest = (payload, fields, history, toast) => ({
    type: `GET_MERCHANT_INFO_REQUEST`,
    payload,
    fields,
    history,
    toast,
});

export const getMerchantInfoSuccess = payload => ({
    type: GET_MERCHANT_INFO_SUCCESS,
    payload,
});

export const getMerchantInfoError = (payload,history,toast) => ({
    type: GET_MERCHANT_INFO_ERROR,
    payload,
    history,
    toast,
});

export const getMerchantSectionInfoRequest = (
    payload,
    fields,
    sectionType,
    history
) => ({
    type: GET_MERCHANT_SECTION_INFO_REQUEST,
    payload,
    fields,
    sectionType,
    history,
});

export const getMerchantSectionInfoError = payload => ({
    type: GET_MERCHANT_SECTION_INFO_ERROR,
    payload,
});

export const getMerchantSectionInfoSuccess = payload => ({
    type: GET_MERCHANT_SECTION_INFO_SUCCESS,
    payload,
});

export const setEntityDataRequest = (payload, entityType) => ({
    type: SET_SELECTED_ENTITY_REQUEST,
    payload,
    entityType,
});

export const setEntityDataSuccess = payload => ({
    type: SET_SELECTED_ENTITY_SUCCESS,
    payload,
});

export const setEntityDataError = payload => ({
    type: FETCH_PG_CONFIG_EDIT_ERROR,
    payload,
});

export const fetchPgConfigDetailsRequest = payload => ({
    type: FETCH_PG_CONFIG_EDIT_REQUEST,
    payload,
});

export const fetchPgConfigDetailsSuccess = payload => ({
    type: FETCH_PG_CONFIG_EDIT_SUCCESS,
    payload,
});

export const fetchPgConfigDetailsError = payload => ({
    type: SET_SELECTED_ENTITY_ERROR,
    payload,
});

export const fetchRouterDetailsRequest = payload => ({
    type: FETCH_ROUTER_DETAILS_REQUEST,
    payload,
});


export const fetchRouterDetailsSuccess = payload => ({
    type: FETCH_ROUTER_DETAILS_SUCCESS,
    payload,
});

export const fetchRouterDetailsError = payload => ({
    type: FETCH_ROUTER_DETAILS_ERROR,
    payload,
});

export const fetchSurchargeDetailsRequest = payload => ({
    type: FETCH_SURCHARGE_DETAILS_REQUEST,
    payload,
});

export const fetchSurchargeDetailsSuccess = payload => ({
    type: FETCH_SURCHARGE_DETAILS_SUCCESS,
    payload,
});

export const fetchSurchargeDetailsError = payload => ({
    type: FETCH_SURCHARGE_DETAILS_ERROR,
    payload,
});

export const updateMerchantDataRequest = (payload, sectionType) => ({
    type: UPDATE_MERCHANT_DATA_REQUEST,
    payload,
    sectionType,
});

export const updateMerchantDataSuccess = (payload, sectionType) => ({
    type: UPDATE_MERCHANT_DATA_SUCCESS,
    payload,
    sectionType,
});

export const updateMerchantDataError = payload => ({
    type: UPDATE_MERCHANT_DATA_ERROR,
    payload,
});

export const updatePgConfigDataRequest = (payload, sectionType) => ({
    type: UPDATE_PG_CONFIG_DATA_REQUEST,
    payload,
    sectionType,
});

export const updatePgConfigDataSuccess = (payload, sectionType) => ({
    type: UPDATE_PG_CONFIG_DATA_SUCCESS,
    payload,
    sectionType,
});

export const updatePgConfigDataError = payload => ({
    type: UPDATE_PG_CONFIG_DATA_ERROR,
    payload,
});

export const updateRoutingDataRequest = (payload, sectionType) => ({
    type: UPDATE_ROUTING_DATA_REQUEST,
    payload,
    sectionType,
});

export const updateRoutingDataSuccess = (payload, sectionType) => ({
    type: UPDATE_ROUTING_DATA_SUCCESS,
    payload,
    sectionType,
});

export const updateRoutingDataError = payload => ({
    type: UPDATE_ROUTING_DATA_ERROR,
    payload,
});

export const updateSurchargeDataRequest = (payload, sectionType) => ({
    type: UPDATE_SURCHARGE_DATA_REQUEST,
    payload,
    sectionType,
});

export const updateSurchargeDataSuccess = (payload, sectionType) => ({
    type: UPDATE_SURCHARGE_DATA_SUCCESS,
    payload,
    sectionType,
});

export const updateSurchargeDataError = payload => ({
    type: UPDATE_SURCHARGE_DATA_ERROR,
    payload,
});

export const updateSectionDataRequest = (payload, sectionType) => ({
    type: UPDATE_SECTION_DETAILS_REQUEST,
    payload,
    sectionType,
});

export const updateSectionDataSuccess = (payload, sectionType) => ({
    type: UPDATE_SECTION_DETAILS_SUCCESS,
    payload,
    sectionType,
});

export const updateSectionDataError = payload => ({
    type: UPDATE_SECTION_DETAILS_ERROR,
    payload,
});

export const resetUpdateDataSuccessKey = () => ({
    type: RESET_UPDATE_DATA_SUCCESS_KEY,
});

export const updateSettlementDataRequest = (payload, sectionType) => ({
    type: UPDATE_SETTLEMENT_DATA_REQUEST,
    payload,
    sectionType,
});

export const updateSettlementDataSuccess = (payload, sectionType) => ({
    type: UPDATE_SETTLEMENT_DATA_SUCCESS,
    payload,
    sectionType,
});

export const updateSettlementDataError = payload => ({
    type: UPDATE_SETTLEMENT_DATA_ERROR,
    payload,
});

export const fetchBasicFormData = payload => ({
    type: FETCH_BASIC_FORM_DATA,
    payload,
});

export const fetchBasicFormSuccess = payload => ({
    type: FETCH_BASIC_FORM_DATA_SUCCESS,
    payload,
});

export const fetchBasicFormError = payload => ({
    type: FETCH_BASIC_FORM_DATA_ERROR,
    payload,
});

export const addMerchantStepUpdateMakerRequest = (
    payload,
    sectionType,
    makerDetails,
    customisedReports,
) => ({
    type: ADD_MERCHANT_STEP_UPDATE_MAKER_REQUEST,
    payload,
    sectionType,
    makerDetails,
    customisedReports,
});

export const addMerchantStepUpdateMakerSuccess = (
    payload,
    sectionType,
    makerDetails
) => ({
    type: ADD_MERCHANT_STEP_UPDATE_MAKER_SUCCESS,
    payload,
    sectionType,
    makerDetails,
});

export const addMerchantStepUpdateMakerError = (
    payload,
    sectionType,
    makerDetails
) => ({
    type: ADD_MERCHANT_STEP_UPDATE_MAKER_ERROR,
    payload,
    sectionType,
    makerDetails,
});

